import { Button } from "@similarweb/ui-components";
import * as React from "react";
import { ChipDownContainer, EllipsisDropdownItem } from "@similarweb/ui-components";
import type { IColumnsPickerLiteProps } from "@similarweb/ui-components";
import { ColumnsPickerLite } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";
import { colorsPalettes, mixins } from "@similarweb/styles";
import styled, { css } from "styled-components";
import BoxSubtitle from "pro-features/components/BoxSubtitle/src/BoxSubtitle";
import { PrimaryBoxTitle } from "pro-features/styled components/StyledBoxTitle/src/StyledBoxTitle";
import { DownloadButtonMenu } from "../../../../components/React/DownloadButtonMenu/DownloadButtonMenu";
import MetricsCompareBars from "../../../../components/React/MetricsCompareBars/MetricsCompareBars";
import { i18nFilter } from "app/filters/i18nFilter";
import { minVisitsAbbrFilter, numberFilter, percentageFilter, suffixFilter } from "app/filters/ngFilters";
import { IncomingReferralsAdvancedFilterService } from "app/services/AdvancedFilterService/IncomingReferralsAdvancedFilter";
import { allTrackers } from "app/services/track/track";
import { DownloadExcelContainer } from "app/pages/workspace/StyledComponent";
import { CategoryDistribution } from "../CategoryDisterbution";
import { SingleBox } from "../single/IncomingTrafficSingleTableTop";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import {
    Container,
    Filter,
    Filters,
    FiltersBottom,
    FiltersGrow,
    FiltersTop,
    LoaderWrapper,
    Number,
    Right,
    SearchContainerWrapper,
    Section,
    SectionContainer,
    SectionWrapper,
    Separator,
    SubTitleReferrals,
    Text,
    TotalItem,
} from "../StyledComponents";
import DurationService from "app/services/DurationService";
import { adaptDomainCategoryItems } from "app/pages/website-analysis/audience-interests/single/AudienceInterestsTableTop/AudienceInterestsCategoriesManager";
import { MultiCategoriesChipDown } from "pro-features/components/MultiCategoriesChipDown/src/MultiCategoriesChipDown";
import { Checkbox } from "@similarweb/ui-components";
import categoryService from "app/common/services/categoryService";
import type { ICategory } from "app/common/services/categoryService.types";
import type { HrefOptions, RawParams, StateOrName } from "@uirouter/react";
import {
    onChipAdd,
    onChipRemove,
} from "app/pages/website-analysis/traffic-sources/search/components/WebsiteKeywordsPageUtillities";
import { EBooleanSearchActions } from "app/pages/website-analysis/traffic-sources/search/BooleanSearchWithBothKeywordsAndWebsite";
import { BooleanSearchWithBothKeywordsAndWebsiteWrapper } from "app/pages/website-analysis/traffic-sources/search/BooleanSearchWithBothKeywordsAndWebsiteWrapper";
import { Loader } from "../Loader";
import { AddToDashboard } from "app/components/dashboard/AddToDashboard/AddToDashboard";
import type { IWidgetModelTypesWebSource } from "app/components/widget/widget-types/Widget";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";
import { isPaidExcelAllowed } from "app/services/PaidExcelService/isPaidExcelAllowed";
import { DomainSelection } from "app/components/React/TableSelectionComponents/DomainSelection";

interface IIncomingTrafficCompareTableTopProps {
    allCategories: Array<{
        Count: number;
        Name: string;
        Value: number;
    }>;
    topCategories: Array<{
        Count: number;
        Name: string;
        Value: number;
    }>;
    totalSectionData: {
        totalShare: number;
        totalUnGroupedCount: number;
        totalVisits: number;
    };
    isLoadingData: boolean;
    onFilterChange: any;
    selectedCategory?: string;
    selectedCategoryId?: string;
    selectedLimits?: string;
    excelLink: string;
    tableColumns: any[];
    onClickToggleColumns: (index) => void;
    referralsTrafficShare: Array<{
        color: string;
        name: string;
        percentage: number;
        value: number;
        valueText: string;
        width: number;
    }>;
    topics: Array<{ Name: string; Value: number }>;
    categoriesData: any[];
    domainMetaData: any[];
    filtersStateObject?: {
        IncludeUrls: string;
        ExcludeUrls: string;
        filter: string;
        webSource: string;
    };
    downloadExcelPermitted?: boolean;
    onCheckboxChange(params: { field: string; value: boolean }): void;
    params: any;
    current: () => IRouterState;
    onBooleanSearchChange: (params) => void;
    href: (stateOrName: StateOrName, params?: RawParams, options?: HrefOptions) => string;
    convertLimitsToApiParam: (limits: string) => string;
    totalCount: number;
    selectedRows: Array<{ Domain: string }>;
    clearAllSelectedRows: () => void;
    showToast: (href: string, text: string, label: string) => void;
}

const ChipdownItem = styled.div`
    flex-grow: 0;
    .ChipItemText {
        max-width: 314px;
        @media (max-width: 1758px) and (min-width: 1601px) {
            max-width: 317px;
        }
        @media (max-width: 1600px) and (min-width: 1367px) {
            max-width: 260px;
        }
        @media (max-width: 1366px) {
            max-width: 180px;
        }
    }
`;

const Title = styled.div`
    padding: 24px 24px 22px 24px;
`;

const MetricsCompareBarsStyled = styled(MetricsCompareBars)<{ isFetching: boolean; items: any }>`
    ${css`
        flex-grow: 1;
        margin-bottom: 29px;
    `}
`;

const MetricsCompareBarsTitle = styled.div`
    ${mixins.setFont({ $size: 14, $color: colorsPalettes.carbon[500] })};
    margin-top: 19px;
    margin-bottom: 19px;
`;

const CategoryDistributionWrapper = styled(SingleBox)`
    margin: 24px 0;
`;

const i18n = i18nFilter();

export class IncomingTrafficCompareTableTop extends React.PureComponent<IIncomingTrafficCompareTableTopProps, any> {
    public static defaultProps = {
        allCategories: [],
        selectedCategory: "",
        topics: [],
    };

    private initialCategories = [...categoryService.getCategories()];

    constructor(props) {
        super(props);
        // "Unknown" is created in order to be able to uncheck "Unknown" category under "All Categories" filter in Incoming Traffic page
        this.initialCategories.push({ text: "Unknown", id: "Unknown", children: [] } as ICategory);
    }
    public updateTableByParamsChange(params) {
        this.props.onFilterChange({ ExcludeUrls: params.ExcludeUrls, IncludeUrls: params.IncludeUrls }, false);
    }
    public componentDidUpdate(
        prevProps: Readonly<IIncomingTrafficCompareTableTopProps>,
        prevState: Readonly<any>,
        snapshot?: any,
    ) {
        if (prevProps.params.referralsCategory !== this.props.params.referralsCategory) {
            this.onIndustryClick(this.props.params.referralsCategory);
        }
        if (prevProps.params.IncludeUrls !== this.props.params.IncludeUrls) {
            this.updateTableByParamsChange(this.props.params);
        }
        if (prevProps.params.ExcludeUrls !== this.props.params.ExcludeUrls) {
            this.updateTableByParamsChange(this.props.params);
        }
    }

    public render() {
        const { webSource, duration } = this.props.params;
        const durationObject = DurationService.getDurationData(duration);
        const is28d = duration === "28d";
        const [fromDate, toDate] = [durationObject.raw.from, durationObject.raw.to];
        const selectedLimitsName = this.getAdvancedFilterSelectedText();
        const subTitleFilters = [
            {
                filter: "date",
                value: {
                    from: fromDate.valueOf(),
                    to: toDate.valueOf(),
                    useRangeDisplay: !is28d && fromDate.format("YYYY-MM") !== toDate.format("YYYY-MM"),
                },
            },
            {
                filter: "webSource",
                value: webSource,
            },
        ];
        const excelDownloadUrl = this.props.downloadExcelPermitted ? this.props.excelLink : "";
        let allCategories;
        if (this.props.allCategories.length === 0 && this.props.selectedCategory) {
            allCategories = this.initialCategories.reduce((result, current) => {
                if (this.props.selectedCategory.includes(current.id)) {
                    result.push({ Name: current.id, Value: 0, Count: 0 });
                }
                current.children.forEach(({ id }) => {
                    if (this.props.selectedCategory.includes(id)) {
                        result.push({ Name: id, Value: 0, Count: 0 });
                    }
                });
                return result;
            }, []);
        } else {
            allCategories = this.props.allCategories;
        }
        const categories = adaptDomainCategoryItems(allCategories);
        const selectedCategoryIds = this.getSelectedCategoryIds(categories);
        const advancedFilter = (
            <ChipdownItem>
                <ChipDownContainer
                    width={340}
                    onClick={this.onSelectAdvancedFilter}
                    tooltipDisabled={true}
                    selectedText={selectedLimitsName ?? ""}
                    onCloseItem={this.onClearAdvancedFilter}
                    buttonText={i18n("analysis.compare.trafficsource.referrals.advanced.placeholder")}
                    onToggle={this.onAdvancedFilterToggle}
                    noResultsMessage={i18n("dropdown.no.results")}
                >
                    {this.getPresetsOptions()}
                </ChipDownContainer>
            </ChipdownItem>
        );
        const onBooleanSearchChange = (params) => {
            this.updateTableByParamsChange(params);
        };
        const { onCheckboxChange: onCheckboxChangeProp } = this.props;
        const onCheckboxChange = (field) => () => {
            const currentValue = this.props.params[field] === "true";
            onCheckboxChangeProp({ field, value: !currentValue });
            this.props.onFilterChange({ [field]: !currentValue }, false);
        };
        const isPaidExcelPermitted = isPaidExcelAllowed();

        return (
            <div>
                <Title>
                    <PrimaryBoxTitle>{i18n("analysis.common.trafficsource.referrals.websites")}</PrimaryBoxTitle>
                    <SubTitleReferrals>
                        <BoxSubtitle filters={subTitleFilters} />
                    </SubTitleReferrals>
                </Title>
                <Separator />
                {this.props.totalSectionData && (
                    <SectionContainer>
                        <SectionWrapper>
                            <Section margin={19}>
                                <Filters>
                                    <FiltersTop>
                                        <FiltersGrow>
                                            <Filter>
                                                <ChipdownItem>
                                                    <MultiCategoriesChipDown
                                                        key={Math.random()}
                                                        ignoreParentOnSelect={false}
                                                        categories={categories}
                                                        initialSelectedCategories={selectedCategoryIds}
                                                        onDone={this.onSelectCategory}
                                                        buttonText="All Categories"
                                                        searchPlaceholder="Search for categories"
                                                    />
                                                </ChipdownItem>
                                            </Filter>
                                            {selectedLimitsName ? (
                                                <Filter>
                                                    <PlainTooltip tooltipContent={selectedLimitsName}>
                                                        {advancedFilter}
                                                    </PlainTooltip>
                                                </Filter>
                                            ) : (
                                                <Filter>{advancedFilter}</Filter>
                                            )}
                                        </FiltersGrow>
                                        <Button
                                            type="flat"
                                            isDisabled={this.isClearAllDisabled()}
                                            onClick={this.onClearAll}
                                        >
                                            {i18n("forms.buttons.clearall.text")}
                                        </Button>
                                    </FiltersTop>
                                    <FiltersBottom>
                                        <Filter>
                                            <PlainTooltip
                                                placement="top"
                                                tooltipContent={i18n(
                                                    "analysis.common.trafficsource.referrals.table.filters.newly.tooltip",
                                                )}
                                            >
                                                <div>
                                                    <Checkbox
                                                        onClick={onCheckboxChange("IncludeNewReferrals")}
                                                        label={i18n(
                                                            "analysis.common.trafficsource.referrals.table.filters.newly.label",
                                                        )}
                                                        selected={this.props.params.IncludeNewReferrals === "true"}
                                                    />
                                                </div>
                                            </PlainTooltip>
                                        </Filter>
                                        <Filter>
                                            <PlainTooltip
                                                placement="top"
                                                tooltipContent={i18n(
                                                    "analysis.common.trafficsource.referrals.table.filters.trending.tooltip",
                                                )}
                                            >
                                                <div>
                                                    <Checkbox
                                                        onClick={onCheckboxChange("IncludeTrendingReferrals")}
                                                        label={i18n(
                                                            "analysis.common.trafficsource.referrals.table.filters.trending.label",
                                                        )}
                                                        selected={this.props.params.IncludeTrendingReferrals === "true"}
                                                    />
                                                </div>
                                            </PlainTooltip>
                                        </Filter>
                                    </FiltersBottom>
                                </Filters>
                            </Section>
                        </SectionWrapper>
                        <Separator />
                        {this.props.isLoadingData ? (
                            <LoaderWrapper>
                                <Loader />
                            </LoaderWrapper>
                        ) : (
                            <>
                                <Section margin={19}>
                                    <TotalItem>
                                        <Number>
                                            {minVisitsAbbrFilter()(this.props.totalSectionData.totalVisits)}
                                        </Number>
                                        <Text>{i18n("analysis.common.trafficsource.referrals.visits")}</Text>
                                    </TotalItem>
                                    <TotalItem>
                                        <Number>
                                            {suffixFilter()(
                                                percentageFilter()(this.props.totalSectionData.totalShare, 2),
                                                "%",
                                            )}
                                        </Number>
                                        <Text>
                                            {i18n("shared.totals.total")}{" "}
                                            {i18n("analysis.common.trafficsource.referrals.visits")}
                                        </Text>
                                    </TotalItem>
                                    <TotalItem>
                                        <Number>
                                            {numberFilter()(this.props.totalSectionData.totalUnGroupedCount)}
                                        </Number>
                                        <Text>{i18n("analysis.common.trafficsource.referrals.websites")}</Text>
                                    </TotalItem>
                                </Section>
                                <Separator />
                                <MetricsCompareBarsTitle>
                                    {i18n("analysis.compare.trafficsource.referrals.compare.title")}
                                </MetricsCompareBarsTitle>
                                {this.props.referralsTrafficShare && (
                                    <MetricsCompareBarsStyled
                                        items={[{ bars: this.props.referralsTrafficShare }]}
                                        isFetching={false}
                                        title={i18n("analysis.compare.trafficsource.referrals.tooltip.title")}
                                    />
                                )}
                                <CategoryDistributionWrapper border={1}>
                                    <CategoryDistribution
                                        domains={this.props.domainMetaData}
                                        data={this.props.categoriesData}
                                        getLink={this.getCategoryLink}
                                    />
                                </CategoryDistributionWrapper>
                            </>
                        )}
                    </SectionContainer>
                )}
                <Container>
                    <SearchContainerWrapper>
                        <BooleanSearchWithBothKeywordsAndWebsiteWrapper
                            placeholder={i18nFilter()(
                                "analysis.common.trafficsource.referrals.visits.boolean.search.placeholder",
                            )}
                            onChipAdd={onChipAdd}
                            onChipRemove={onChipRemove}
                            booleanSearchAction={EBooleanSearchActions.WEBSITES}
                            onApplyChanges={onBooleanSearchChange}
                        />
                        <Right>
                            <FlexRow>
                                <DownloadExcelContainer>
                                    <DownloadButtonMenu
                                        PaidExcel={isPaidExcelPermitted}
                                        totalCount={this.props.totalCount}
                                        Excel={true}
                                        downloadUrl={excelDownloadUrl}
                                        exportFunction={this.trackExcelDownload}
                                        excelLocked={!this.props.downloadExcelPermitted}
                                    />
                                </DownloadExcelContainer>
                                <div>
                                    <ColumnsPickerLite
                                        {...this.getColumnsPickerLiteProps()}
                                        withTooltip
                                        translations={{
                                            tooltip: i18n("workspace.sales.column.picker"),
                                            getSelectedAmountText: ({ selectedValue, totalValue }) => i18n("common.columnsPicker.selectedAmount", {
                                                selected: selectedValue,
                                                total: totalValue,
                                            }),
                                            mandatoryField: i18n("common.columnsPicker.mandatoryField"),
                                            apply: i18n("common.apply"),
                                        }}
                                    />
                                </div>
                                <div>
                                    <AddToDashboard
                                        modelType="fromWebsite"
                                        type="TopReferralsDashboardTable"
                                        metric="TopReferrals"
                                        webSource={
                                            this.props.filtersStateObject.webSource as IWidgetModelTypesWebSource
                                        }
                                        filters={{
                                            IncludeUrls: this.props.filtersStateObject.IncludeUrls,
                                            ExcludeUrls: this.props.filtersStateObject.ExcludeUrls,
                                            filter: this.convertFiltersToDashboard(
                                                this.props.filtersStateObject.filter,
                                            ),
                                        }}                                       
                                    />
                                </div>
                            </FlexRow>
                        </Right>
                    </SearchContainerWrapper>
                </Container>
              <DomainSelection
                    key="DomainSelection"
                    showToast={this.props.showToast}
                    clearAllSelectedRows={this.props.clearAllSelectedRows}
                    selectedRows={this.props.selectedRows}
             />
            </div>
        );
    }
    private getSelectedCategoryIds = (categories): string[] => {
        return this.props.selectedCategory
            ? categories.reduce((result, current) => {
                  if (this.props.selectedCategory.includes(current.id)) {
                      result.push(current.id);
                  }
                  current.sons.forEach(({ id }) => {
                      if (this.props.selectedCategory.includes(id)) {
                          result.push(id);
                      }
                  });
                  return result;
              }, [])
            : [];
    };

    private getCategoryLink = (category) => {
        return decodeURIComponent(
            this.props.href(this.props.current().name, {
                referralsCategory: category,
            }),
        );
    };

    private onIndustryClick = (value, updateUrl = false) => {
        this.props.onFilterChange({ referralsCategory: value }, updateUrl);
    };

    private onAdvancedFilterToggle = (isOpen: boolean) => {
        if (isOpen) {
            allTrackers.trackEvent("Drop Down", "open", "advanced filter");
        } else {
            allTrackers.trackEvent("Drop Down", "close", "advanced filter");
        }
    };

    private getAdvancedFilterSelectedText = () => {
        const keys = this.props.params.key.split(",").map((domain) => {
            return {
                name: domain,
            };
        });
        const filter = this.props.params.limits;
        return IncomingReferralsAdvancedFilterService.getAdvancedFilterSelectedText(keys, filter, i18n);
    };

    private getColumnsPickerLiteProps = (): Omit<IColumnsPickerLiteProps, "translations"> => {
        const columns = this.props.tableColumns.reduce((res, col, index) => {
            if (!col.fixed) {
                return [
                    ...res,
                    {
                        key: index.toString(),
                        displayName: col.displayName,
                        visible: col.visible,
                    },
                ];
            }
            return res;
        }, []);
        return {
            columns,
            onColumnToggle: this.onColumnToggle,
            onPickerToggle: () => null,
            maxHeight: 264,
            width: "auto",
        };
    };

    private onColumnToggle = (key) => {
        this.props.onClickToggleColumns(parseInt(key));
    };

    private getPresetsOptions = () => {
        const filters = IncomingReferralsAdvancedFilterService.getAllFilters();
        return filters.map(({ api, id, name, tooltip }, index) => {
            return (
                <EllipsisDropdownItem
                    key={`advanced-filter-item-${index}`}
                    id={id}
                    tooltipText={i18n(tooltip)}
                    selected={id === this.props.selectedLimits}
                >
                    {i18n(name)}
                </EllipsisDropdownItem>
            );
        });
    };

    private onSelectCategory = (categories) => {
        const value = categories ? categories.map((x) => x.id).join(",") : "Clear Filter";
        allTrackers.trackEvent("Drop Down", "click", `Table/Category/${value}`);
        this.onIndustryClick(value, true);
    };

    private onSelectAdvancedFilter = (selected) => {
        const value = selected ? selected.id : "Clear Filter";
        allTrackers.trackEvent("Drop Down", "click", `advanced filter/${value}`);
        this.props.onFilterChange({ limits: selected && selected.id }, true);
    };

    private onClearAdvancedFilter = () => {
        this.onSelectAdvancedFilter(null);
    };

    private isClearAllDisabled = () => {
        const { referralsCategory, limits, IncludeNewReferrals, IncludeTrendingReferrals } = this.props.params;
        return !referralsCategory && !limits && !IncludeNewReferrals && !IncludeTrendingReferrals;
    };

    private onClearAll = () => {
        allTrackers.trackEvent("Button", "click", "Table/Clear all");
        const resetParams = {
            IncludeNewReferrals: null,
            IncludeTrendingReferrals: null,
            limits: null,
            referralsCategory: null,
        };
        this.props.onFilterChange(resetParams, true);
    };

    private trackExcelDownload = () => {
        allTrackers.trackEvent("Download", "submit-ok", "Table/Excel");
    };

    private convertFiltersToDashboard = (filter = "") => {
        let allFilters = filter;
        if (this.props.params.referralsCategory) {
            if (filter !== "") {
                allFilters = allFilters.concat(",");
            }
            const cat = this.props.params.referralsCategory.split(",")[0];
            allFilters = allFilters.concat(`category;category;"${cat}"`);
        }
        return allFilters;
    };

}
